import { atom } from 'jotai'

import type { UserModel } from '@/shared/api'

export const authProfileAtom = atom<UserModel | undefined>(undefined)
